import { render } from "./TheKnNav.vue?vue&type=template&id=5fe38516&scoped=true&ts=true"
import script from "./TheKnNav.vue?vue&type=script&lang=ts"
export * from "./TheKnNav.vue?vue&type=script&lang=ts"

import "./TheKnNav.vue?vue&type=style&index=0&id=5fe38516&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe38516"]])

export default __exports__